import { take, put, call, select } from "redux-saga/effects";
import { httpGet, httpPost, httpPut, httpDelete } from "../../services";
import { getAppFeatureSuccessAction } from "../actions/authActions";

import {
  PlatformConfigurationConst,
  getGlobalEmailConfigLoadingAction,
  getGlobalEmailConfigSuccessAction,
  getGlobalEmailConfigErrorAction,
  EmailConfigResponseSchema,
  saveGlobalEmailConfigLoadingAction,
  saveGlobalEmailConfigSuccessAction,
  saveGlobalEmailConfigErrorAction,
  SaveEmailConfigBodyAndResponseSchema,
  GetApiKeySchema,
  getApiKeyLoadingAction,
  getApiKeySuccessAction,
  getApiKeyErrorAction,
  GetSMSSettingsAndConfigSchema,
  getSMSSettingsAndConfigLoadingAction,
  getSMSSettingsAndConfigSuccessAction,
  getSMSSettingsAndConfigErrorAction,
  getSMSTemplatesLoadingAction,
  getSMSTemplatesSuccessAction,
  getSMSTemplatesErrorAction,
  GetSMSProviderConfigSchema,
  getSMSProviderConfigLoadingAction,
  getSMSProviderConfigSuccessAction,
  getSMSProviderConfigErrorAction,
  SaveSMSConfigSchema,
  saveSMSConfigLoadingAction,
  saveSMSConfigSuccessAction,
  saveSMSConfigErrorAction,
  ResetSMSConfigSchema,
  resetSMSConfigLoadingAction,
  resetSMSConfigSuccessAction,
  resetSMSConfigErrorAction,
  getGlobalSMSSettingsLoadingAction,
  getGlobalSMSSettingsSuccessAction,
  getGlobalSMSSettingsErrorAction,
  SMSSettingsResponseSchema,
  saveGlobalSMSSettingsLoadingAction,
  saveGlobalSMSSettingsSuccessAction,
  saveGlobalSMSSettingsErrorAction,
  SaveSMSSettingsBodyAndResponseSchema,
  SaveSMSSettingsByTypePayload,
  saveSMSSettingsLoadingAction,
  saveSMSSettingsSuccessAction,
  saveSMSSettingsErrorAction,
  GetRolesSchema,
  getRolesLoadingAction,
  getRolesSuccessAction,
  getRolesErrorAction,
  getConfigurationListLoadingAction,
  GetConfigurationListSchema,
  getConfigurationListSuccessAction,
  getConfigurationListErrorAction,
  TransferConfigurationsArgs,
  transferConfigurationsLoadingAction,
  TransferConfigurationsSchema,
  transferConfigurationsSuccessAction,
  transferConfigurationsErrorAction,
  getSocialProviderListLoadingAction,
  getSocialProviderListSuccessAction,
  getSocialProviderListErrorAction,
  GetSocialProviderListSchema,
  getMultipleSocialProviderLoadingAction,
  getMultipleSocialProviderErrorAction,
  getMultipleSocialProviderSuccessAction,
  postMultipleSocialProviderLoadingAction,
  postMultipleSocialProviderErrorAction,
  postMultipleSocialProviderSuccessAction,
  putMultipleSocialProviderLoadingAction,
  putMultipleSocialProviderErrorAction,
  putMultipleSocialProviderSuccessAction,
  deleteMultipleSocialProviderLoadingAction,
  deleteMultipleSocialProviderErrorAction,
  deleteMultipleSocialProviderSuccessAction,
  getAuthServerAPIConfigLoadingAction,
  getAuthServerAPIConfigSuccessAction,
  getAuthServerAPIConfigErrorAction,
  deleteAuthServerAPIConfigLoadingAction,
  deleteAuthServerAPIConfigSuccessAction,
  deleteAuthServerAPIConfigErrorAction,
  postAuthServerAPIConfigLoadingAction,
  postAuthServerAPIConfigSuccessAction,
  postAuthServerAPIConfigErrorAction,
  putAuthServerAPIConfigLoadingAction,
  putAuthServerAPIConfigSuccessAction,
  putAuthServerAPIConfigErrorAction,
  setAppFeaturesLoadingAction,
  setAppFeaturesSuccessAction,
  setAppFeaturesErrorAction,
  renewCertificateLoadingAction,
  renewCertificateSuccessAction,
  renewCertificateErrorAction,
  getCustomSMSProviderConfigLoadingAction,
  GetCustomSMSProviderConfigSchema,
  getCustomSMSProviderConfigSuccessAction,
  getCustomSMSProviderConfigErrorAction,
  saveCustomSMSConfigSuccessAction,
  saveCustomSMSConfigErrorAction,
  saveCustomSMSConfigLoadingAction,
  SaveCustomSMSConfigSchema,
  getAvailableSSOIntegrationLoadingAction,
  getAvailableSSOIntegrationSuccessAction,
  getAvailableSSOIntegrationErrorAction,
  postSSOIntegrationLoadingAction,
  postSSOIntegrationSuccessAction,
  postSSOIntegrationErrorAction,
  deleteSSOIntegrationLoadingAction,
  deleteSSOIntegrationSuccessAction,
  deleteSSOIntegrationErrorAction,
  getOAuthProvidersLoadingAction,
  getOAuthProvidersSuccessAction,
  getOAuthProvidersErrorAction,
  getJWTProvidersLoadingAction,
  getJWTProvidersSuccessAction,
  getJWTProvidersErrorAction,
  getSAMLProvidersLoadingAction,
  getSAMLProvidersSuccessAction,
  getSAMLProvidersErrorAction,
  postRoleAndPermissionLoadingAction,
  postRoleAndPermissionErrorAction,
  postRoleAndPermissionSuccessAction,
  putRolesAndPermissionLoadingAction,
  putRolesAndPermissionErrorAction,
  putRolesAndPermissionSuccessAction,
  deleteRolesAndPermissionLoadingAction,
  deleteRolesAndPermissionErrorAction,
  deleteRolesAndPermissionSuccessAction,
  deletePermissionOnlyLoadingAction,
  deletePermissionOnlyErrorAction,
  deletePermissionOnlySuccessAction,
  putDefaultRoleLoadingAction,
  putDefaultRoleErrorAction,
  putDefaultRoleSuccessAction,
  getRolesAction,
  getOIDCandOAuthAppsSuccessAction,
  getOIDCandOAuthAppsErrorAction,
  getOIDCandOAuthAppsLoadingAction,
  getSSOConnectionLoadingAction,
  getSSOConnectionSuccessAction,
  getSSOConnectionErrorAction,
  getDataMappingsLoadingAction,
  getDataMappingsSuccessAction,
  getDataMappingsErrorAction,
  getCustomProviderDataMappingLoadingAction,
  getCustomProviderDataMappingSuccessAction,
  getCustomProviderDataMappingErrorAction,
  postOIDCandOAuthAppsLoadingAction,
  postOIDCandOAuthAppsSuccessAction,
  postOIDCandOAuthAppsErrorAction,
  putOIDCandOAuthAppsLoadingAction,
  putOIDCandOAuthAppsSuccessAction,
  putOIDCandOAuthAppsErrorAction,
  deleteOIDCandOAuthAppsLoadingAction,
  deleteOIDCandOAuthAppsSuccessAction,
  deleteOIDCandOAuthAppsErrorAction,
  OIDCAndOAuthAppSchema,
  deleteOIDCAppsErrorAction,
  deleteOIDCAppsSuccessAction,
  deleteOIDCAppsLoadingAction,
  OIDCAppSchema,
  putOIDCAppsLoadingAction,
  putOIDCAppsSuccessAction,
  putOIDCAppsErrorAction,
  postOIDCAppsErrorAction,
  postOIDCAppsSuccessAction,
  postOIDCAppsLoadingAction,
  getOIDCAppsErrorAction,
  getOIDCAppsSuccessAction,
  getOIDCAppsLoadingAction,
  getOptionalCaptchaApisLoadingAction,
  getOptionalCaptchaApisSuccessAction,
  getOptionalCaptchaApisErrorAction,
  postOAuthProvidersSuccessAction,
  postOAuthProvidersLoadingAction,
  postOAuthProvidersErrorAction,
  putOAuthProvidersLoadingAction,
  putOAuthProvidersSuccessAction,
  putOAuthProvidersErrorAction,
  deleteOAuthProvidersLoadingAction,
  deleteOAuthProvidersSuccessAction,
  deleteOAuthProvidersErrorAction,
  postJWTProvidersLoadingAction,
  postJWTProvidersSuccessAction,
  postJWTProvidersErrorAction,
  putJWTProvidersLoadingAction,
  putJWTProvidersSuccessAction,
  putJWTProvidersErrorAction,
  deleteJWTProvidersLoadingAction,
  deleteJWTProvidersSuccessAction,
  deleteJWTProvidersErrorAction,
  postSAMLProvidersLoadingAction,
  postSAMLProvidersSuccessAction,
  postSAMLProvidersErrorAction,
  putSAMLProvidersLoadingAction,
  putSAMLProvidersSuccessAction,
  putSAMLProvidersErrorAction,
  deleteSAMLProvidersLoadingAction,
  deleteSAMLProvidersSuccessAction,
  deleteSAMLProvidersErrorAction,
  getSocialProviderOptionLoadingAction,
  GetSocialProviderOptionSchema,
  getSocialProviderOptionSuccessAction,
  getSocialProviderOptionErrorAction,
  getSocialProvidersLoadingAction,
  GetSocialProvidersSchema,
  getSocialProvidersSuccessAction,
  getSocialProvidersErrorAction,
  postSocialProviderOptionLoadingAction,
  postSocialProviderOptionSuccessAction,
  postSocialProviderOptionErrorAction,
  postSocialProvidersLoadingAction,
  postSocialProvidersSuccessAction,
  postSocialProvidersErrorAction,
  postAppleSettingsLoadingAction,
  postAppleSettingsSuccessAction,
  postAppleSettingsErrorAction,
  postSocialProvidersOrderLoadingAction,
  SocialProviderOrderResponse,
  postSocialProvidersOrderSuccessAction,
  postSocialProvidersOrderErrorAction,
  getSAMLAppsLoadingAction,
  getSAMLAppsSuccessAction,
  getSAMLAppsErrorAction,
  postSAMLAppsLoadingAction,
  postSAMLAppsSuccessAction,
  postSAMLAppsErrorAction,
  putSAMLAppsSuccessAction,
  putSAMLAppsErrorAction,
  putSAMLAppsLoadingAction,
  deleteSAMLAppsLoadingAction,
  deleteSAMLAppsSuccessAction,
  deleteSAMLAppsErrorAction,
  getHostedPluginAppsAction,
  getHostedPluginAppsLoadingAction,
  getHostedPluginAppsSuccessAction,
  getHostedPluginAppsErrorAction,
  SaveHostedPluginPayload,
  saveHostedPluginLoadingAction,
  saveHostedPluginSuccessAction,
  saveHostedPluginErrorAction,
  deleteHostedPluginLoadingAction,
  deleteHostedPluginSuccessAction,
  deleteHostedPluginErrorAction,
  getJWTAppsLoadingAction,
  getJWTAppsSuccessAction,
  getJWTAppsErrorAction,
  postJWTAppsLoadingAction,
  postJWTAppsSuccessAction,
  postJWTAppsErrorAction,
  putJWTAppsLoadingAction,
  putJWTAppsSuccessAction,
  putJWTAppsErrorAction,
  deleteJWTAppsLoadingAction,
  deleteJWTAppsSuccessAction,
  deleteJWTAppsErrorAction,
  getDefaultRoleLoadingAction
} from "../actions/platformConfigurationActions";
import { getSamlConfigSuccessAction, PutSamlConfigSchema } from "../actions/teamActions";
import { RootSchema } from "../reducers";
import { getPasskeyError, getPasskeyRequest, getPasskeySuccess, PasskeyPayloadSchema, updatePasskeyError, updatePasskeyRequest, updatePasskeySuccess } from "../features/authentication/passkeys";

/**
 * Workers
 */

function* getGlobalEmailConfigHandler() {
  try {
    yield put(getGlobalEmailConfigLoadingAction());
    const response: EmailConfigResponseSchema = yield httpGet("/platform-configuration/global-email-configuration");
    yield put(getGlobalEmailConfigSuccessAction(response));
  } catch (e: any) {
    yield put(getGlobalEmailConfigErrorAction(e.message));
  }
}

function* saveGlobalEmailConfigHandler(payload: SaveEmailConfigBodyAndResponseSchema) {
  try {
    yield put(saveGlobalEmailConfigLoadingAction());

    const response: SaveEmailConfigBodyAndResponseSchema = yield httpPut("/platform-configuration/global-email-configuration", {}, payload);
    yield put(saveGlobalEmailConfigSuccessAction(response));
  } catch (e: any) {
    yield put(saveGlobalEmailConfigErrorAction(e.message));
  }
}

function* getAuthServerApiConfigHandler() {
  try {
    yield put(getAuthServerAPIConfigLoadingAction());
    const response = yield httpGet("/platform-configuration/authserverapiconfig");
    if (response.ErrorCode) {
      throw new Error(response.Messsage || response.Description || "");
    }
    yield put(getAuthServerAPIConfigSuccessAction(response));
  } catch (e: any) {
    yield put(getAuthServerAPIConfigErrorAction(e.messsage));
  }
}

function* deleteAuthServerApiConfigHandler(payload) {
  try {
    yield put(deleteAuthServerAPIConfigLoadingAction());

    const response = yield httpDelete("/platform-configuration/authserverapiconfig", {}, payload);
    if (response.isdeleted) {
      let getAuthServerConfigApiData = yield select((state: RootSchema) => state.platformConfiguration.getAuthServerConfigApi.Data);
      getAuthServerConfigApiData = getAuthServerConfigApiData.filter((e) => e.Id !== payload.id) ? getAuthServerConfigApiData.filter((e) => e.Id !== payload.id) : [];
      yield put(getAuthServerAPIConfigLoadingAction());
      yield put(
        getAuthServerAPIConfigSuccessAction({
          Data: getAuthServerConfigApiData
        })
      );
    }
    if (response.ErrorCode) {
      throw new Error(response.Messsage || response.Description);
    }

    yield put(deleteAuthServerAPIConfigSuccessAction(response));
  } catch (e: any) {
    yield put(deleteAuthServerAPIConfigErrorAction(e.message));
  }
}

function* updateAuthServerApiConfigHandler(payload) {
  try {
    yield put(putAuthServerAPIConfigLoadingAction());

    const response = yield httpPut("/platform-configuration/authserverapiconfig", {}, payload);

    if (response.ErrorCode) {
      const errorMessage = response.ErrorCode === 1189 ? response.Description : response.Messsage || response.Description;
      throw new Error(errorMessage);
    }

    yield put(putAuthServerAPIConfigSuccessAction(response));
    if (response.Edited) {
      let getAuthServerConfigApiData = yield select((state: RootSchema) => state.platformConfiguration.getAuthServerConfigApi.Data);
      getAuthServerConfigApiData = getAuthServerConfigApiData.map((data) => {
        if (data.Id === payload.id) {
          delete payload.id;
          payload.Id = data.Id;
          data = payload;
        }
        return data;
      });

      yield put(getAuthServerAPIConfigLoadingAction());
      yield put(
        getAuthServerAPIConfigSuccessAction({
          Data: getAuthServerConfigApiData
        })
      );
    }
    if (response.ErrorCode) {
      throw new Error(response.Messsage || response.Description);
    }
  } catch (e: any) {
    yield put(putAuthServerAPIConfigErrorAction(e.message));
  }
}
function* postAuthServerApiConfigHandler(payload) {
  try {
    yield put(postAuthServerAPIConfigLoadingAction());

    const response = yield httpPost("/platform-configuration/authserverapiconfig", {}, payload);
    if (response.ErrorCode) {
      const errorMessage = response.ErrorCode === 1189 ? response.Description : response.Messsage || response.Description;
      throw new Error(errorMessage);
    }

    const getAuthServerConfigApiData = yield select((state: RootSchema) => state.platformConfiguration.getAuthServerConfigApi.Data);
    let defaultApi = {};
    for (let i = 0; i < getAuthServerConfigApiData.length; i++) {
      if (!getAuthServerConfigApiData[i].Id) defaultApi = getAuthServerConfigApiData[i];
    }
    if (response.Data?.length) {
      response.Data.unshift(defaultApi);
    }

    yield put(postAuthServerAPIConfigSuccessAction(response));
    yield put(getAuthServerAPIConfigLoadingAction());
    yield put(getAuthServerAPIConfigSuccessAction(response));
  } catch (e: any) {
    yield put(postAuthServerAPIConfigErrorAction(e.message));
  }
}

function* postAppFeatureHandler(payload) {
  try {
    yield put(setAppFeaturesLoadingAction());

    const response = yield httpPost("/platform-configuration/app-features", {}, payload);
    if (response.ErrorCode) {
      throw new Error(response.Messsage || response.Description);
    }
    const features: string[] = [];
    response.Data.map((feature) => {
      features[feature.feature] = feature.status;
    });
    yield put(setAppFeaturesSuccessAction(features));
    yield put(getAppFeatureSuccessAction(features));
  } catch (e: any) {
    yield put(setAppFeaturesErrorAction(e.message));
  }
}

function* putRenewCertificateHandler(payload) {
  try {
    yield put(renewCertificateLoadingAction());

    const response: PutSamlConfigSchema = yield httpPut("/platform-configuration/renew-certificate", {}, payload);
    if (!response["ErrorCode"]) {
      yield put(renewCertificateSuccessAction(response));
      if (response.Data && payload.type === "teamsso") {
        yield put(
          getSamlConfigSuccessAction({
            ...response.Data.filter((resp) => resp.Provider === payload.Provider)[0],
            queriedAppName: payload.Provider.split("saml_")[1]
          })
        );
      }
    } else {
      yield put(renewCertificateErrorAction(response["Message"]));
    }
  } catch (e: any) {
    yield put(renewCertificateErrorAction(e.message));
  }
}

function* getAvailableSSOIntegrationHandler() {
  try {
    yield put(getAvailableSSOIntegrationLoadingAction());

    const response: any = yield httpGet("/platform-configuration/available-integrations");
    if (response.ErrorCode) {
      yield put(getAvailableSSOIntegrationErrorAction(response.Message || response.Description || ""));
    } else {
      yield put(
        getAvailableSSOIntegrationSuccessAction({
          ...response,
          Message: "",
          Description: ""
        })
      );
    }
  } catch (e: any) {
    yield put(getAvailableSSOIntegrationErrorAction(e.message));
  }
}

function* postSSOIntegrationHandler(payload: any) {
  try {
    yield put(postSSOIntegrationLoadingAction());
    let response;
    if (payload.type === "sp") {
      delete payload.type;
      response = yield httpPost("/platform-configuration/integration/samlsp", {}, payload);
    } else {
      delete payload.type;
      response = yield httpPost("/platform-configuration/integration/saml", {}, payload);
    }
    if (response.ErrorCode) {
      throw new Error(response.Message || response.Description || "Something went wrong");
    } else {
      yield put(postSSOIntegrationSuccessAction(response));
    }
  } catch (e: any) {
    yield put(postSSOIntegrationErrorAction(e.message));
  }
}

function* deleteSSOIntegrationHandler(payload: any) {
  try {
    yield put(deleteSSOIntegrationLoadingAction());
    let response;
    if (payload.type === "sp") {
      delete payload.type;
      response = httpDelete("/platform-configuration/adfs?v=" + `${new Date().getTime()}`, {}, { Provider: payload.AppName });
    } else {
      delete payload.type;
      response = yield httpDelete("/platform-configuration/saml?v=" + new Date().getTime(), {}, payload);
    }

    if (response.ErrorCode) {
      throw new Error(response.Messsage || response.Description || "");
    } else {
      yield put(
        deleteSSOIntegrationSuccessAction({
          ...response,
          AppName: payload.AppName
        })
      );
    }
  } catch (e: any) {
    yield put(deleteSSOIntegrationErrorAction(e.message));
  }
}

function* getApiKeyHandler() {
  try {
    yield put(getApiKeyLoadingAction());

    const response: GetApiKeySchema = yield httpGet("/security-configuration/api-credentials/keys", { fields: "Key", helpwidgetParams: true });
    yield put(getApiKeySuccessAction(response));
  } catch (e: any) {
    yield put(getApiKeyErrorAction(e.message));
  }
}

function* getSMSSettingsAndConfigHandler() {
  try {
    yield put(getSMSSettingsAndConfigLoadingAction());

    const data: GetSMSSettingsAndConfigSchema = yield httpGet("/platform-configuration/sms-settings-and-config", {});

    yield put(getSMSSettingsAndConfigSuccessAction({ ...data }));
  } catch (e: any) {
    yield put(getSMSSettingsAndConfigErrorAction(e.message));
  }
}

function* getSMSTemplatesHandler() {
  try {
    yield put(getSMSTemplatesLoadingAction());

    let data = yield httpGet("/platform-configuration/sms-template", {});
    if (data.ErrorCode) {
      if (data.ErrorCode === 1094) {
        data = { Data: [] };
      } else {
        throw new Error(data.Message || data.Description);
      }
    }

    yield put(getSMSTemplatesSuccessAction({ ...data }));
  } catch (e) {
    yield put(getSMSTemplatesErrorAction(e.message));
  }
}

function* getSMSProviderConfigHandler() {
  try {
    yield put(getSMSProviderConfigLoadingAction());

    const data: GetSMSProviderConfigSchema = yield httpGet("/platform-configuration/sms-config", {});

    yield put(getSMSProviderConfigSuccessAction({ ...data }));
  } catch (e: any) {
    yield put(getSMSProviderConfigErrorAction(e.message));
  }
}

function* getCustomSMSProviderConfigHandler() {
  try {
    yield put(getCustomSMSProviderConfigLoadingAction());

    const data: GetCustomSMSProviderConfigSchema = yield httpGet("/platform-configuration/sms-config/custom", {});

    yield put(getCustomSMSProviderConfigSuccessAction({ ...data }));
  } catch (e: any) {
    yield put(getCustomSMSProviderConfigErrorAction(e.message));
  }
}

function* saveSMSConfigHandler(payload: any) {
  try {
    yield put(saveSMSConfigLoadingAction());

    const data: SaveSMSConfigSchema = yield httpPost("/platform-configuration/sms-config", {}, payload);

    if (data.ErrorCode) {
      if (data.ErrorCode === 1189) {
        throw new Error(data.Description);
      }
      throw new Error(data.Message || data.Description);
    }

    yield put(saveSMSConfigSuccessAction({ ...data }));
    // yield put(saveCustomSMSConfigSuccessAction({}));
  } catch (e: any) {
    yield put(saveSMSConfigErrorAction(e.message));
  }
}

function* saveCustomSMSConfigHandler(payload: any) {
  try {
    yield put(saveCustomSMSConfigLoadingAction());

    const data: SaveCustomSMSConfigSchema = yield httpPost("/platform-configuration/sms-config/custom", {}, payload);

    if (data.ErrorCode) {
      if (data.ErrorCode === 1189 || data.ErrorCode === 1263) {
        throw new Error(data.Description);
      }
      throw new Error(data.Message || data.Description);
    }

    yield put(saveCustomSMSConfigSuccessAction({ ...data }));
    // yield put(saveSMSConfigSuccessAction({}));
  } catch (e: any) {
    yield put(saveCustomSMSConfigErrorAction(e.message));
  }
}
function* resetSMSConfigHandler() {
  try {
    yield put(resetSMSConfigLoadingAction());

    const data: ResetSMSConfigSchema = yield httpPut("/platform-configuration/sms-config/reset", {});

    yield put(resetSMSConfigSuccessAction({ ...data }));
    // yield put(saveSMSConfigSuccessAction({}));
    // yield put(saveCustomSMSConfigSuccessAction({}));
  } catch (e: any) {
    yield put(resetSMSConfigErrorAction(e.message));
  }
}

function* getGlobalSMSSettingsHandler() {
  try {
    yield put(getGlobalSMSSettingsLoadingAction());
    const response: SMSSettingsResponseSchema = yield httpGet("/platform-configuration/global-sms-configuration");
    if (response.ErrorCode) {
      throw new Error(response.Message || response.Description);
    }
    yield put(getGlobalSMSSettingsSuccessAction(response));
  } catch (e: any) {
    yield put(getGlobalSMSSettingsErrorAction(e.message));
  }
}

function* saveGlobalSMSSettingsHandler(payload: SaveSMSSettingsBodyAndResponseSchema) {
  try {
    yield put(saveGlobalSMSSettingsLoadingAction());

    const response: SaveSMSSettingsBodyAndResponseSchema = yield httpPut("/platform-configuration/global-sms-configuration", {}, payload);
    yield put(saveGlobalSMSSettingsSuccessAction(response));
  } catch (e: any) {
    yield put(saveGlobalSMSSettingsErrorAction(e.message));
  }
}

function* getRolesHandler() {
  try {
    yield put(getRolesLoadingAction());

    const data: GetRolesSchema = yield httpGet("/platform-configuration/role");
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }

    yield put(getRolesSuccessAction({ ...data }));
  } catch (e: any) {
    yield put(getRolesErrorAction(e.message));
  }
}

function* postRolesAndPermissionHandler(req: any) {
  try {
    yield put(postRoleAndPermissionLoadingAction());

    const res: any = yield httpPost("/platform-configuration/role", {}, req);
    if (res.ErrorCode && res.Description) {
      throw new Error(res.Description);
    }

    yield put(postRoleAndPermissionSuccessAction(res));
    yield put(getRolesAction());
  } catch (e) {
    yield put(postRoleAndPermissionErrorAction(e.message));
    yield put(getRolesAction());
  }
}

function* putRolesAndPermissionHandler(req: any) {
  try {
    yield put(putRolesAndPermissionLoadingAction());

    const res = yield httpPut("/platform-configuration/role/permission", {}, req);
    if (res.ErrorCode && res.Description) {
      throw new Error(res.Description);
    }

    yield put(putRolesAndPermissionSuccessAction(res));
    yield put(getRolesAction());
  } catch (e) {
    yield put(putRolesAndPermissionErrorAction(e.message));
    yield put(getRolesAction());
  }
}

function* deleteRolesAndPermissionHandler(req: any) {
  try {
    yield put(deleteRolesAndPermissionLoadingAction());

    const res = yield httpDelete("/platform-configuration/role", {}, req);
    if (res.ErrorCode && res.Description) {
      throw new Error(res.Description);
    }

    yield put(deleteRolesAndPermissionSuccessAction(res));
    yield put(getRolesAction());
  } catch (e) {
    yield put(deleteRolesAndPermissionErrorAction(e.message));
    yield put(getRolesAction());
  }
}

function* deletePermissionOnlyHandler(req: any) {
  try {
    yield put(deletePermissionOnlyLoadingAction());

    const res = yield httpDelete("/platform-configuration/role/permission", {}, req);
    if (res.ErrorCode && res.Description) {
      throw new Error(res.Description);
    }

    yield put(deletePermissionOnlySuccessAction(res));
    yield put(getRolesAction());
  } catch (e) {
    yield put(deletePermissionOnlyErrorAction(e.message));
    yield put(getRolesAction());
  }
}

function* getDefaultRoleHandler() {
  try {
    yield put(getDefaultRoleLoadingAction());

    const res = yield httpGet("/platform-configuration/role/default");
    if (res.ErrorCode && res.Description) {
      throw new Error(res.Description);
    }

    yield put(putDefaultRoleSuccessAction(res));
  } catch (e) {
    yield put(putDefaultRoleErrorAction(e.message));
  }
}

function* putDefaultRoleHandler(req: any) {
  try {
    yield put(putDefaultRoleLoadingAction());

    const res = yield httpPut("/platform-configuration/role/default", {}, req);
    if (res.ErrorCode && res.Description) {
      throw new Error(res.Description);
    }

    yield put(putDefaultRoleSuccessAction(res));
    yield put(getRolesAction());
  } catch (e) {
    yield put(putDefaultRoleErrorAction(e.message));
    yield put(getRolesAction());
  }
}
function* getConfigurationListHandler() {
  try {
    yield put(getConfigurationListLoadingAction());

    const data: GetConfigurationListSchema = yield httpGet("/platform-configuration/configuration/list");

    yield put(getConfigurationListSuccessAction(data));
  } catch (e: any) {
    yield put(getConfigurationListErrorAction(e.message));
  }
}

function* getSocialProviderListHandler() {
  try {
    yield put(getSocialProviderListLoadingAction());

    const data: GetSocialProviderListSchema = yield httpGet("/platform-configuration/social-provider/list");

    yield put(getSocialProviderListSuccessAction(data));
  } catch (e: any) {
    yield put(getSocialProviderListErrorAction(e.message));
  }
}

function* transferConfigurationsHandler(payload: TransferConfigurationsArgs) {
  try {
    yield put(transferConfigurationsLoadingAction());

    const data: TransferConfigurationsSchema = yield httpPost("/platform-configuration/configuration/transfer", {}, payload);

    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(transferConfigurationsSuccessAction(data));
  } catch (e: any) {
    yield put(transferConfigurationsErrorAction(e.message));
  }
}

function* getMultipleSocialProviderHandler() {
  try {
    yield put(getMultipleSocialProviderLoadingAction());
    // GetSocialProviderListSchema
    let data: any = yield httpGet("/platform-configuration/multipel-social-provider");
    if (data.ErrorCode === 1193 || data.ErrorCode === 1195) {
      data = { response: [] };
    } else if (data.ErrorCode && data.ErrorCode !== 1195) {
      throw new Error(data.Description || data.Message);
    }
    yield put(getMultipleSocialProviderSuccessAction(data.Data));
  } catch (e: any) {
    yield put(getMultipleSocialProviderErrorAction(e.message));
  }
}
function* postMultipleSocialProviderHandler(payload: any) {
  try {
    yield put(postMultipleSocialProviderLoadingAction());
    // GetSocialProviderListSchema
    const data: any = yield httpPost("/platform-configuration/multipel-social-provider", {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Description || data.Message);
    }
    yield put(postMultipleSocialProviderSuccessAction(data.Data));
  } catch (e: any) {
    yield put(postMultipleSocialProviderErrorAction(e.message));
  }
}
function* putMultipleSocialProviderHandler(payload: any) {
  try {
    yield put(putMultipleSocialProviderLoadingAction());
    // GetSocialProviderListSchema
    const data: any = yield httpPut("/platform-configuration/multipel-social-provider", {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Description || data.Message);
    }
    yield put(putMultipleSocialProviderSuccessAction(data.Data));
  } catch (e: any) {
    yield put(putMultipleSocialProviderErrorAction(e.message));
  }
}

function* deleteMultipleSocialProviderHandler(payload: { provider: string; appname: string }) {
  try {
    yield put(deleteMultipleSocialProviderLoadingAction());
    // GetSocialProviderListSchema
    let data: any = yield httpDelete("/platform-configuration/multipel-social-provider/delete/" + payload.provider + "/" + payload.appname, {}, {});
    if (data.ErrorCode) {
      throw new Error(data.Description || data.Message);
    } else {
      data = { ...data, ...payload };
    }
    yield put(deleteMultipleSocialProviderSuccessAction(data));
  } catch (e: any) {
    yield put(deleteMultipleSocialProviderErrorAction(e.message));
  }
}

function* getOAuthProvidersHandler() {
  try {
    yield put(getOAuthProvidersLoadingAction());
    const data: any = yield httpGet("/platform-configuration/custom-oauth-provider/all?v=" + `${new Date().getTime()}`);
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(getOAuthProvidersSuccessAction({ ...data }));
  } catch (e) {
    yield put(getOAuthProvidersErrorAction(e.message));
  }
}

function* postOAuthProvidersHandler(payload: any) {
  try {
    yield put(postOAuthProvidersLoadingAction());
    const data: any = yield httpPost("/platform-configuration/custom-oauth-provider?v=" + `${new Date().getTime()}`, {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(postOAuthProvidersSuccessAction(data));
  } catch (e) {
    yield put(postOAuthProvidersErrorAction(e.message));
  }
}

function* putOAuthProvidersHandler(payload: any) {
  try {
    yield put(putOAuthProvidersLoadingAction());
    const data: any = yield httpPut("/platform-configuration/custom-oauth-provider?v=" + `${new Date().getTime()}`, {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(putOAuthProvidersSuccessAction(data));
  } catch (e) {
    yield put(putOAuthProvidersErrorAction(e.message));
  }
}

function* deleteOAuthProvidersHandler(payload: any) {
  try {
    yield put(deleteOAuthProvidersLoadingAction());
    const data: any = yield httpDelete("/platform-configuration/custom-oauth-provider?v=" + new Date().getTime(), {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(deleteOAuthProvidersSuccessAction(data));
  } catch (e) {
    yield put(deleteOAuthProvidersErrorAction(e.message));
  }
}

function* getJWTProvidersHandler() {
  try {
    yield put(getJWTProvidersLoadingAction());
    const data: any = yield httpGet("/platform-configuration/customidp/jwt/sp?v=" + `${new Date().getTime()}`);
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(getJWTProvidersSuccessAction(data));
  } catch (e) {
    yield put(getJWTProvidersErrorAction(e.message));
  }
}

function* postJWTProvidersHandler(payload: any) {
  try {
    yield put(postJWTProvidersLoadingAction());
    const data: any = yield httpPost("/platform-configuration/customidp/jwt/sp?v=" + new Date().getTime(), {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(postJWTProvidersSuccessAction(data));
  } catch (e) {
    yield put(postJWTProvidersErrorAction(e.message));
  }
}

function* putJWTProvidersHandler(payload: any) {
  try {
    yield put(putJWTProvidersLoadingAction());
    const data: any = yield httpPut("/platform-configuration/customidp/jwt/sp?v=" + new Date().getTime(), {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(putJWTProvidersSuccessAction(data));
  } catch (e) {
    yield put(putJWTProvidersErrorAction(e.message));
  }
}

function* deleteJWTProvidersHandler(payload: any) {
  try {
    yield put(deleteJWTProvidersLoadingAction());
    const data: any = yield httpDelete("/platform-configuration/customidp/jwt/sp?v=" + new Date().getTime(), {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(deleteJWTProvidersSuccessAction(data));
  } catch (e) {
    yield put(deleteJWTProvidersErrorAction(e.message));
  }
}

function* getSAMLProvidersHandler() {
  try {
    yield put(getSAMLProvidersLoadingAction());
    const res: any = yield httpGet("/platform-configuration/adfs?v=" + `${new Date().getTime()}`);
    if (res.ErrorCode) {
      throw new Error(res.Message || res.Description);
    }
    yield put(getSAMLProvidersSuccessAction(res.Data));
  } catch (e) {
    yield put(getSAMLProvidersErrorAction(e.message));
  }
}

function* postSAMLProvidersHandler(payload: any) {
  try {
    yield put(postSAMLProvidersLoadingAction());
    const data: any = yield httpPost("/platform-configuration/adfs?v=" + `${new Date().getTime()}`, {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Messsage || data.Description);
    }
    yield put(postSAMLProvidersSuccessAction(data));
  } catch (e) {
    yield put(postSAMLProvidersErrorAction(e.message));
  }
}

function* putSAMLProvidersHandler(payload: any) {
  try {
    yield put(putSAMLProvidersLoadingAction());
    const data: any = yield httpPut("/platform-configuration/adfs?v=" + `${new Date().getTime()}`, {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Messsage || data.Description);
    }
    yield put(putSAMLProvidersSuccessAction(data));
  } catch (e) {
    yield put(putSAMLProvidersErrorAction(e.message));
  }
}

function* deleteSAMLProvidersHandler(payload: any) {
  try {
    yield put(deleteSAMLProvidersLoadingAction());
    const data: any = yield httpDelete("/platform-configuration/adfs?v=" + `${new Date().getTime()}`, {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Messsage || data.Description);
    }
    yield put(deleteSAMLProvidersSuccessAction(data));
  } catch (e) {
    yield put(deleteSAMLProvidersErrorAction(e.message));
  }
}

function* getOIDCandOAuthAppsHandler() {
  try {
    yield put(getOIDCandOAuthAppsLoadingAction());
    const data: any = yield httpGet("/platform-configuration/sso/oauth?v=" + new Date().getTime());
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }

    yield put(getOIDCandOAuthAppsSuccessAction(data.Data));
  } catch (e) {
    yield put(getOIDCandOAuthAppsErrorAction(e.message));
  }
}

function* getSAMLAppsHandler() {
  try {
    yield put(getSAMLAppsLoadingAction());
    const data: any = yield httpGet("/platform-configuration/saml/all?v=" + new Date().getTime());
    if (data.ErrorCode) {
      throw new Error(data.Messsage || data.Description);
    }
    yield put(
      getSAMLAppsSuccessAction(
        data.Data.filter((r) => {
          if (r.ApplicationType !== "service") {
            return r;
          }
        })
      )
    );
  } catch (e) {
    yield put(getSAMLAppsErrorAction(e.message));
  }
}

function* postSAMLAppsHandler(payload: any) {
  try {
    yield put(postSAMLAppsLoadingAction());

    delete payload.type;
    const response = yield httpPost("/platform-configuration/saml?v=" + new Date().getTime(), {}, payload);

    if (response.ErrorCode) {
      if (response.ErrorCode === 1189) {
        throw new Error(response.Description || response.Messsage || "Something went wrong");
      }
      throw new Error(response.Messsage || response.Description || "");
    } else {
      yield put(postSAMLAppsSuccessAction(response.Data));
      yield put(getSAMLAppsSuccessAction(response.Data));
    }
  } catch (e: any) {
    yield put(postSAMLAppsErrorAction(e.message));
  }
}

function* putSAMLAppsHandler(payload: any) {
  try {
    yield put(putSAMLAppsLoadingAction());

    delete payload.type;
    const response = yield httpPut("/platform-configuration/saml?v=" + new Date().getTime(), {}, payload);

    if (response.ErrorCode) {
      if (response.ErrorCode === 1189) {
        throw new Error(response.Description || response.Messsage || "Something went wrong");
      }
      throw new Error(response.Messsage || response.Description || "");
    } else {
      yield put(putSAMLAppsSuccessAction(response.Data));
      yield put(getSAMLAppsSuccessAction(response.Data));
    }
  } catch (e: any) {
    yield put(putSAMLAppsErrorAction(e.message));
  }
}

function* deleteSAMLAppsHandler(payload: any) {
  try {
    yield put(deleteSAMLAppsLoadingAction());

    delete payload.type;
    const response = yield httpDelete("/platform-configuration/saml?v=" + new Date().getTime(), {}, payload);

    if (response.ErrorCode) {
      throw new Error(response.Messsage || response.Description || "");
    } else {
      yield put(
        deleteSAMLAppsSuccessAction({
          ...response,
          AppName: payload.AppName
        })
      );
    }
  } catch (e: any) {
    yield put(deleteSAMLAppsErrorAction(e.message));
  }
}

function* getJWTAppsHandler() {
  try {
    yield put(getJWTAppsLoadingAction());
    const data: any = yield httpGet("/platform-configuration/jwt/all?v=" + new Date().getTime());
    if (data.ErrorCode) {
      throw new Error(data.Messsage || data.Description);
    }
    yield put(
      getJWTAppsSuccessAction(
        data.Data.filter((r) => {
          if (r.ApplicationType !== "service") {
            return r;
          }
        })
      )
    );
  } catch (e) {
    yield put(getJWTAppsErrorAction(e.message));
  }
}

function* postJWTAppsHandler(payload: any) {
  try {
    yield put(postJWTAppsLoadingAction());

    delete payload.type;
    const response = yield httpPost("/platform-configuration/jwt?v=" + new Date().getTime(), {}, payload);

    if (response.ErrorCode) {
      if (response.ErrorCode === 1189) {
        throw new Error(response.Description || response.Messsage || "Something went wrong");
      }
      throw new Error(response.Messsage || response.Description || "");
    } else {
      yield put(postJWTAppsSuccessAction(response.Data));
      yield put(getJWTAppsSuccessAction(response.Data));
    }
  } catch (e: any) {
    yield put(postJWTAppsErrorAction(e.message));
  }
}

function* putJWTAppsHandler(payload: any) {
  try {
    yield put(putJWTAppsLoadingAction());

    delete payload.type;
    const response = yield httpPut("/platform-configuration/jwt?v=" + new Date().getTime(), {}, payload);

    if (response.ErrorCode) {
      if (response.ErrorCode === 1189) {
        throw new Error(response.Description || response.Messsage || "Something went wrong");
      }
      throw new Error(response.Messsage || response.Description || "");
    } else {
      yield put(putJWTAppsSuccessAction(response.Data));
      yield put(getJWTAppsSuccessAction(response.Data));
    }
  } catch (e: any) {
    yield put(putJWTAppsErrorAction(e.message));
  }
}

function* deleteJWTAppsHandler(payload: any) {
  try {
    yield put(deleteJWTAppsLoadingAction());

    delete payload.type;
    const response = yield httpDelete("/platform-configuration/jwt?v=" + new Date().getTime(), {}, payload);

    if (response.ErrorCode) {
      throw new Error(response.Messsage || response.Description || "");
    } else {
      yield put(
        deleteJWTAppsSuccessAction({
          ...response,
          AppName: payload.AppName
        })
      );
    }
  } catch (e: any) {
    yield put(deleteJWTAppsErrorAction(e.message));
  }
}

function* getHostedPluginAppsHandler() {
  try {
    yield put(getHostedPluginAppsLoadingAction());
    const response: any = yield httpGet("/platform-configuration/hosted-plugin?v=" + new Date().getTime());
    if (response.ErrorCode && response.ErrorCode !== 7962) {
      throw new Error(response.Message || response.Description || "Something went wrong");
    }

    const hostedPlugins = (response.Data || []).filter((item) => item.ApplicationType !== "service");
    yield put(getHostedPluginAppsSuccessAction(hostedPlugins));
  } catch (e: any) {
    yield put(getHostedPluginAppsErrorAction(e.message));
  }
}

function* syncHostedPluginApps(response?: any) {
  const hostedPlugins = response?.Data || response?.data;
  if (Array.isArray(hostedPlugins)) {
    const filtered = hostedPlugins.filter((item) => item.ApplicationType !== "service");
    yield put(getHostedPluginAppsSuccessAction(filtered));
  } else {
    yield put(getHostedPluginAppsAction());
  }
}

const getHostedPluginErrorMessage = (response: any) => {
  const code = response?.errorCode ?? response?.ErrorCode;
  if (code === 1112) {
    return "Store name exists in one of the SSO connectors. Please use a different name.";
  }
  if (code === 1189) {
    return response?.description || response?.Description || response?.message || response?.Message || "Something went wrong";
  }
  return response?.message || response?.Message || response?.description || response?.Description || "Something went wrong";
};

interface HostedPluginMutationConfig {
  method: typeof httpPost | typeof httpPut | typeof httpDelete;
  loadingAction: () => any;
  errorAction: (error: string) => any;
  successAction: (data: any) => any;
  selectPayload?: (response: any, requestPayload: any, originalPayload: any) => any;
}

function* hostedPluginMutation(payload: any, config: HostedPluginMutationConfig) {
  try {
    yield put(config.loadingAction());
    const requestPayload = { ...payload };
    delete requestPayload.type;
    const response = yield config.method("/platform-configuration/hosted-plugin?v=" + new Date().getTime(), {}, requestPayload);

    if (response.errorCode || response.ErrorCode) {
      throw new Error(getHostedPluginErrorMessage(response));
    }

    const selectedPayload = config.selectPayload ? config.selectPayload(response, requestPayload, payload) : response;
    yield put(config.successAction(selectedPayload));
    yield* syncHostedPluginApps(response);
  } catch (e: any) {
    yield put(config.errorAction(e.message));
  }
}

function* saveHostedPluginHandler(payload: SaveHostedPluginPayload) {
  const method = payload.operation === "update" ? httpPut : httpPost;
  yield* hostedPluginMutation(payload.data, {
    method,
    loadingAction: saveHostedPluginLoadingAction,
    errorAction: saveHostedPluginErrorAction,
    successAction: saveHostedPluginSuccessAction,
    selectPayload: payload.operation === "create" ? (response) => response.Data : undefined
  });
}

function* deleteHostedPluginHandler(payload: Record<string, any>) {
  yield* hostedPluginMutation(payload, {
    method: httpDelete,
    loadingAction: deleteHostedPluginLoadingAction,
    errorAction: deleteHostedPluginErrorAction,
    successAction: deleteHostedPluginSuccessAction,
    selectPayload: (response, requestPayload) => ({
      ...response,
      StoreName: requestPayload.StoreName
    })
  });
}

function* getSSOConnectionHandler() {
  try {
    yield put(getSSOConnectionLoadingAction());
    const data: any = yield httpGet("/platform-configuration/sso/connections");
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }

    yield put(getSSOConnectionSuccessAction(data));
  } catch (e) {
    yield put(getSSOConnectionErrorAction(e.message));
  }
}

function* getDataMappingHandler() {
  try {
    yield put(getDataMappingsLoadingAction());
    const data: any = yield httpGet("/platform-configuration/saml-clients/data-mappings?v=" + new Date().getTime());
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }

    yield put(getDataMappingsSuccessAction(data));
  } catch (e) {
    yield put(getDataMappingsErrorAction(e.message));
  }
}

function* getCustomProviderDataMappingHandler() {
  try {
    yield put(getCustomProviderDataMappingLoadingAction());
    const data: any = yield httpGet("/platform-configuration/data-mappings?v=" + new Date().getTime());
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }

    yield put(getCustomProviderDataMappingSuccessAction(data));
  } catch (e) {
    yield put(getCustomProviderDataMappingErrorAction(e.message));
  }
}

function* postOIDCandOAuthAppsHandler(payload: OIDCAndOAuthAppSchema) {
  try {
    yield put(postOIDCandOAuthAppsLoadingAction());

    const data: any = yield httpPost("/platform-configuration/sso/oauth?v=" + new Date().getTime(), {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Description || data.Message);
    }
    yield put(
      postOIDCandOAuthAppsSuccessAction({
        Data: data
      })
    );
    // yield put(getOIDCandOAuthAppsAction());
  } catch (e: any) {
    yield put(postOIDCandOAuthAppsErrorAction(e.message));
  }
}
function* putOIDCandOAuthAppsHandler(payload: any) {
  try {
    yield put(putOIDCandOAuthAppsLoadingAction());

    const data: any = yield httpPut("/platform-configuration/sso/oauth?v=" + new Date().getTime(), {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Description || data.Message);
    }
    yield put(putOIDCandOAuthAppsSuccessAction(data));
    // yield put(getOIDCandOAuthAppsAction());
  } catch (e: any) {
    yield put(putOIDCandOAuthAppsErrorAction(e.message));
  }
}

function* deleteOIDCandOAuthAppsHandler(payload: any) {
  try {
    yield put(deleteOIDCandOAuthAppsLoadingAction());

    const data: any = yield httpDelete("/platform-configuration/sso/oauth?v=" + new Date().getTime(), {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(deleteOIDCandOAuthAppsSuccessAction(data));
    // yield put(getOIDCandOAuthAppsAction());
  } catch (e: any) {
    yield put(deleteOIDCandOAuthAppsErrorAction(e.message));
  }
}

function* getOIDCAppsHandler() {
  try {
    yield put(getOIDCAppsLoadingAction());
    const data: any = yield httpGet("/platform-configuration/openid/all?v=" + new Date().getTime());
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }

    yield put(getOIDCAppsSuccessAction(data.Data));
  } catch (e) {
    yield put(getOIDCAppsErrorAction(e.message));
  }
}

function* getOptionalCaptchaApisHandler() {
  try {
    yield put(getOptionalCaptchaApisLoadingAction());
    const data = yield httpGet("/platform-configuration/advance/optional-captcha?v=" + new Date().getTime());
    if (data["ErrorCode"]) {
      throw new Error(data["Message"] || data["Description"]);
    }
    yield put(getOptionalCaptchaApisSuccessAction({ ...data }));
  } catch (e) {
    yield put(getOptionalCaptchaApisErrorAction(e.message));
  }
}

function* postOIDCAppsHandler(payload: OIDCAppSchema) {
  try {
    yield put(postOIDCAppsLoadingAction());

    const data: any = yield httpPost("/platform-configuration/openid?v=" + new Date().getTime(), {}, payload);
    if (data.Data) {
      yield put(postOIDCAppsSuccessAction(data));
    }
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
  } catch (e: any) {
    yield put(postOIDCAppsErrorAction(e.message));
  }
}
function* putOIDCAppsHandler(payload: any) {
  try {
    yield put(putOIDCAppsLoadingAction());

    const data: any = yield httpPut("/platform-configuration/openid?v=" + new Date().getTime(), {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(putOIDCAppsSuccessAction(data));
  } catch (e: any) {
    yield put(putOIDCAppsErrorAction(e.message));
  }
}

function* deleteOIDCAppsHandler(payload: any) {
  try {
    yield put(deleteOIDCAppsLoadingAction());

    const data: any = yield httpDelete("/platform-configuration/openid?v=" + new Date().getTime(), {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Messsage || data.Description);
    }
    yield put(deleteOIDCAppsSuccessAction(data));
  } catch (e: any) {
    yield put(deleteOIDCAppsErrorAction(e.message));
  }
}
function* getPassKeyConfigHandler() {
  try {
    const response: PasskeyPayloadSchema = yield httpGet("/platform-configuration/passkey/config");
    // yield put(getPassKeyConfigSuccessAction(response));
    if (response.ErrorCode === 1297) {
      yield put(getPasskeySuccess({ IsEnabled: false }));
    } else {
      yield put(getPasskeySuccess(response));
    }
  } catch (e) {
    yield put(getPasskeyError(e.message));
    // yield put(getPassKeyConfigErrorAction(e.message));
  }
}

function* updatePassKeyConfigHandler(payload: any) {
  try {
    // yield put(putPassKeyConfigLoadingAction());
    // yield put(updatePasskeyLoading());
    const response: PasskeyPayloadSchema = yield httpPut("/platform-configuration/passkey/config", {}, payload);

    if (response.ErrorCode) {
      throw new Error(response.Description || response.Message);
    }
    // yield put(putPassKeyConfigSuccessAction(response));
    yield put(updatePasskeySuccess(response));
  } catch (e) {
    // yield put(putPassKeyConfigErrorAction(e.message));
    yield put(updatePasskeyError(e.message));
  }
}

function* getSocialProviderOptionHandler() {
  try {
    yield put(getSocialProviderOptionLoadingAction());
    // GetSocialProviderListSchema
    const data: GetSocialProviderOptionSchema = yield httpGet("/platform-configuration/social-providers/options?v=" + `${new Date().getTime()}`);
    if (data.ErrorCode) {
      throw new Error(data.Description || data.Message);
    }
    yield put(getSocialProviderOptionSuccessAction(data));
  } catch (e: any) {
    yield put(getSocialProviderOptionErrorAction(e.message));
  }
}

function* getSocialProvidersHandler() {
  try {
    yield put(getSocialProvidersLoadingAction());
    // GetSocialProviderListSchema
    const data: GetSocialProvidersSchema = yield httpGet("/platform-configuration/social-providers?v=" + `${new Date().getTime()}`);
    if (data.ErrorCode) {
      throw new Error(data.Description || data.Message);
    }
    yield put(getSocialProvidersSuccessAction(data));
  } catch (e: any) {
    yield put(getSocialProvidersErrorAction(e.message));
  }
}

function* postSocialProviderOptionHandler(payload) {
  try {
    yield put(postSocialProviderOptionLoadingAction());
    // GetSocialProviderListSchema
    const data: GetSocialProviderOptionSchema = yield httpPost("/platform-configuration/social-provider/options?v=" + `${new Date().getTime()}`, {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Description || data.Message);
    }
    yield put(getSocialProviderOptionSuccessAction(data));
    yield put(postSocialProviderOptionSuccessAction(data));
  } catch (e: any) {
    yield put(postSocialProviderOptionErrorAction(e.message));
  }
}

function* postSocialProvidersHandler(payload) {
  try {
    yield put(postSocialProvidersLoadingAction());
    // GetSocialProviderListSchema
    const data: GetSocialProvidersSchema = yield httpPost("/platform-configuration/social-providers/status?v=" + `${new Date().getTime()},`, {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Description || data.Message);
    }
    yield put(postSocialProvidersSuccessAction(data));
  } catch (e: any) {
    yield put(postSocialProvidersErrorAction(e.message));
  }
}

function* postAppleConfigHandler(payload) {
  try {
    yield put(postAppleSettingsLoadingAction());
    // GetSocialProviderListSchema
    const data: any = yield httpPost("/platform-configuration/set-appleid-settings?", {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Description || data.Messsage);
    }
    yield put(postAppleSettingsSuccessAction(data));
  } catch (e: any) {
    yield put(postAppleSettingsErrorAction(e.message));
  }
}

function* postSocialProviderOrderHandler(payload) {
  try {
    yield put(postSocialProvidersOrderLoadingAction());
    // GetSocialProviderListSchema
    const data: SocialProviderOrderResponse = yield httpPost("/platform-configuration/social-providers/order?v" + `${new Date().getTime()}`, {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Description || data.Message);
    }
    yield put(postSocialProvidersOrderSuccessAction(data));
  } catch (e: any) {
    yield put(postSocialProvidersOrderErrorAction(e.message));
  }
}

/**
 * Watchers
 */

export function* watchGetOAuthProviders() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_OAUTH_PROVIDERS);
    yield call(getOAuthProvidersHandler);
  }
}

export function* watchPostOAuthProviders() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_OAUTH_PROVIDERS);
    yield call(postOAuthProvidersHandler, payload);
  }
}

export function* watchPutOAuthProviders() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.UPDATE_OAUTH_PROVIDERS);
    yield call(putOAuthProvidersHandler, payload);
  }
}

export function* watchDeleteOAuthProviders() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.DELETE_OAUTH_PROVIDERS);
    yield call(deleteOAuthProvidersHandler, payload);
  }
}

export function* watchGetJWTProviders() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_JWT_PROVIDERS);
    yield call(getJWTProvidersHandler);
  }
}

export function* watchPostJWTProviders() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_JWT_PROVIDERS);
    yield call(postJWTProvidersHandler, payload);
  }
}

export function* watchPutJWTProviders() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.UPDATE_JWT_PROVIDERS);
    yield call(putJWTProvidersHandler, payload);
  }
}

export function* watchDeleteJWTProviders() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.DELETE_JWT_PROVIDERS);
    yield call(deleteJWTProvidersHandler, payload);
  }
}

export function* watchGetSAMLProviders() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_SAML_PROVIDERS);
    yield call(getSAMLProvidersHandler);
  }
}

export function* watchPostSAMLProviders() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_SAML_PROVIDERS);
    yield call(postSAMLProvidersHandler, payload);
  }
}

export function* watchPutSAMLProviders() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.UPDATE_SAML_PROVIDERS);
    yield call(putSAMLProvidersHandler, payload);
  }
}

export function* watchDeleteSAMLProviders() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.DELETE_SAML_PROVIDERS);
    yield call(deleteSAMLProvidersHandler, payload);
  }
}

export function* watchDeleteMultipleSocialProvider() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.DELETE_MULTIPLE_SOCIAL_PROVIDER);
    yield call(deleteMultipleSocialProviderHandler, payload);
  }
}
export function* watchGetMultipleSocialProvider() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_MULTIPLE_SOCIAL_PROVIDER);
    yield call(getMultipleSocialProviderHandler);
  }
}
export function* watchPostMultipleSocialProvider() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_MULTIPLE_SOCIAL_PROVIDER);
    yield call(postMultipleSocialProviderHandler, payload);
  }
}
export function* watchPutMultipleSocialProvider() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.PUT_MULTIPLE_SOCIAL_PROVIDER);
    yield call(putMultipleSocialProviderHandler, payload);
  }
}
export function* watchGetGlobalEmailConfig() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_GLOBAL_EMAIL_CONFIG);
    yield call(getGlobalEmailConfigHandler);
  }
}

export function* watchSaveGlobalEmailConfig() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.SAVE_GLOBAL_EMAIL_CONFIG);
    yield call(saveGlobalEmailConfigHandler, payload);
  }
}

export function* watchGetApiKey() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_API_KEY);
    yield call(getApiKeyHandler);
  }
}

export function* watchGetSMSSettingsAndConfig() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_SMS_SETTINGS_AND_CONFIG);
    yield call(getSMSSettingsAndConfigHandler);
  }
}

export function* watchGetSMSTemplates() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_SMS_TEMPLATES);
    yield call(getSMSTemplatesHandler);
  }
}

export function* watchGetSMSProviderConfig() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_SMS_PROVIDER_CONFIG);
    yield call(getSMSProviderConfigHandler);
  }
}

export function* watchGetCustomSMSProviderConfig() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_CUSTOM_SMS_PROVIDER_CONFIG);
    yield call(getCustomSMSProviderConfigHandler);
  }
}

export function* watchSaveSMSConfig() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.SAVE_SMS_CONFIG);
    yield call(saveSMSConfigHandler, payload);
  }
}

export function* watchSaveCustomSMSConfig() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.SAVE_CUSTOM_SMS_CONFIG);
    yield call(saveCustomSMSConfigHandler, payload);
  }
}

export function* watchResetSMSConfig() {
  while (true) {
    yield take(PlatformConfigurationConst.RESET_SMS_CONFIG);
    yield call(resetSMSConfigHandler);
  }
}

export function* watchGetGlobalSMSSettings() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_GLOBAL_SMS_SETTINGS);
    yield call(getGlobalSMSSettingsHandler);
  }
}

function* saveSMSSettingsHandler(payload: SaveSMSSettingsByTypePayload) {
  try {
    yield put(saveSMSSettingsLoadingAction());
    const response: SaveSMSSettingsBodyAndResponseSchema = yield httpPut("/platform-configuration/sms-settings", {}, payload);
    yield put(saveSMSSettingsSuccessAction(response));
  } catch (e: any) {
    yield put(saveSMSSettingsErrorAction(e.message));
  }
}

export function* watchSaveSMSSettings() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.SAVE_SMS_SETTINGS);
    yield call(saveSMSSettingsHandler, payload);
  }
}

export function* watchSaveGlobalSMSSettings() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.SAVE_GLOBAL_SMS_SETTINGS);
    yield call(saveGlobalSMSSettingsHandler, payload);
  }
}

export function* watchGetRoles() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_ROLES);
    yield call(getRolesHandler);
  }
}
export function* watchPostRolesAndPermission() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_ROLES_AND_PERMISSION);
    yield call(postRolesAndPermissionHandler, payload);
  }
}
export function* watchPutRolesAndPermission() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.PUT_ROLES_AND_PERMISSION);
    yield call(putRolesAndPermissionHandler, payload);
  }
}

export function* watchDeleteRolesAndPermission() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.DELETE_ROLES_AND_PERMISSION);
    yield call(deleteRolesAndPermissionHandler, payload);
  }
}
export function* watchDeletePermissionOnly() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.DELETE_PERMISSION_ONLY);
    yield call(deletePermissionOnlyHandler, payload);
  }
}
export function* watchGetDefaultRole() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_DEFAULT_ROLE);
    yield call(getDefaultRoleHandler);
  }
}
export function* watchPutDefaultRole() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.PUT_DEFAULT_ROLE);
    yield call(putDefaultRoleHandler, payload);
  }
}
export function* watchGetConfigurationList() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_CONFIGURATION_LIST);
    yield call(getConfigurationListHandler);
  }
}

export function* watchGetSocialProviderList() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_SOCIALPROVIDER_LIST);
    yield call(getSocialProviderListHandler);
  }
}

export function* watchTransferConfigurations() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.TRANSFER_CONFIGURATIONS);
    yield call(transferConfigurationsHandler, payload);
  }
}

export function* watchGetAuthServerApiConfig() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_AUTH_SERVER_API_CONFIG);
    yield call(getAuthServerApiConfigHandler);
  }
}

export function* watchDeleteAuthServerApiConfig() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.DELETE_AUTH_SERVER_API_CONFIG);
    yield call(deleteAuthServerApiConfigHandler, payload);
  }
}
export function* watchUpdateAuthServerApiConfig() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.PUT_AUTH_SERVER_API_CONFIG);
    yield call(updateAuthServerApiConfigHandler, payload);
  }
}
export function* watchPostAuthServerApiConfig() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_AUTH_SERVER_API_CONFIG);
    yield call(postAuthServerApiConfigHandler, payload);
  }
}

export function* watchSetAppFeature() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.SET_APP_FEATURES);
    yield call(postAppFeatureHandler, payload);
  }
}

export function* watchRenewCertificate() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.RENEW_CERTIFICATE);
    yield call(putRenewCertificateHandler, payload);
  }
}

export function* watchGetAvailableSSOIntegration() {
  while (true) {
    yield take(PlatformConfigurationConst.AVAILABLE_SSO_INTEGRATION);
    yield call(getAvailableSSOIntegrationHandler);
  }
}

export function* watchPostSSOIntegration() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_SSO_INTEGRATION);
    yield call(postSSOIntegrationHandler, payload);
  }
}

export function* watchDeleteSSOIntegration() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.DELETE_SSO_INTEGRATION);
    yield call(deleteSSOIntegrationHandler, payload);
  }
}

export function* watchGetOIDCandOAuthApps() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_OIDC_AND_OAUTH_APPS);
    yield call(getOIDCandOAuthAppsHandler);
  }
}
export function* watchGetSAMLApps() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_SAML_APPS);
    yield call(getSAMLAppsHandler);
  }
}

export function* watchPostSAMLApps() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_SAML_APPS);
    yield call(postSAMLAppsHandler, payload);
  }
}

export function* watchPutSAMLApps() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.UPDATE_SAML_APPS);
    yield call(putSAMLAppsHandler, payload);
  }
}

export function* watchDeleteSAMLApps() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.DELETE_SAML_APPS);
    yield call(deleteSAMLAppsHandler, payload);
  }
}

export function* watchGetJWTApps() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_JWT_APPS);
    yield call(getJWTAppsHandler);
  }
}

export function* watchPostJWTApps() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_JWT_APPS);
    yield call(postJWTAppsHandler, payload);
  }
}

export function* watchPutJWTApps() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.UPDATE_JWT_APPS);
    yield call(putJWTAppsHandler, payload);
  }
}

export function* watchDeleteJWTApps() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.DELETE_JWT_APPS);
    yield call(deleteJWTAppsHandler, payload);
  }
}

export function* watchGetHostedPluginApps() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_HOSTED_PLUGIN_APPS);
    yield call(getHostedPluginAppsHandler);
  }
}

export function* watchSaveHostedPlugin() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.SAVE_HOSTED_PLUGIN);
    yield call(saveHostedPluginHandler, payload);
  }
}

export function* watchDeleteHostedPlugin() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.DELETE_HOSTED_PLUGIN);
    yield call(deleteHostedPluginHandler, payload);
  }
}

export function* watchGetSSOConnection() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_SSO_CONNECTION);
    yield call(getSSOConnectionHandler);
  }
}

export function* watchGetDataMapping() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_DATA_MAPPING);
    yield call(getDataMappingHandler);
  }
}

export function* watchGetCustomProviderDataMapping() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_CUSTOM_PROVIDER_DATA_MAPPING);
    yield call(getCustomProviderDataMappingHandler);
  }
}

export function* watchPostOIDCandOAuthApps() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_OIDC_AND_OAUTH_APPS);
    yield call(postOIDCandOAuthAppsHandler, payload);
  }
}

export function* watchPutOIDCandOAuthApps() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.PUT_OIDC_AND_OAUTH_APPS);
    yield call(putOIDCandOAuthAppsHandler, payload);
  }
}

export function* watchDeleteOIDCandOAuthApps() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.DELETE_OIDC_AND_OAUTH_APPS);
    yield call(deleteOIDCandOAuthAppsHandler, payload);
  }
}

export function* watchGetOIDCApps() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_OIDC_APPS);
    yield call(getOIDCAppsHandler);
  }
}

export function* watchPostOIDCApps() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_OIDC_APPS);
    yield call(postOIDCAppsHandler, payload);
  }
}

export function* watchPutOIDCApps() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.PUT_OIDC_APPS);
    yield call(putOIDCAppsHandler, payload);
  }
}

export function* watchDeleteOIDCApps() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.DELETE_OIDC_APPS);
    yield call(deleteOIDCAppsHandler, payload);
  }
}

export function* watchGetOptionalCaptcha() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_OPTIONAL_CAPTCHA_APIS);
    yield call(getOptionalCaptchaApisHandler);
  }
}

export function* watchGetPassKeyConfig() {
  while (true) {
    yield take(getPasskeyRequest().type);
    yield call(getPassKeyConfigHandler);
  }
}

export function* watchUpdatePassKeyConfig() {
  while (true) {
    const { payload } = yield take(updatePasskeyRequest.type);
    yield call(updatePassKeyConfigHandler, payload);
  }
}

export function* watchGetSocialProviderOption() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_SOCIALPROVIDER_OPTION);
    yield call(getSocialProviderOptionHandler);
  }
}

export function* watchGetSocialProviders() {
  while (true) {
    yield take(PlatformConfigurationConst.GET_SOCIAL_PROVIDERS);
    yield call(getSocialProvidersHandler);
  }
}

export function* watchPostSocialProviderOption() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_SOCIALPROVIDER_OPTION);
    yield call(postSocialProviderOptionHandler, payload);
  }
}

export function* watchPostSocialProviders() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_SOCIAL_PROVIDERS);
    yield call(postSocialProvidersHandler, payload);
  }
}

export function* watchPostAppleConfig() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_APPLE_CONFIG);
    yield call(postAppleConfigHandler, payload);
  }
}

export function* watchSocialProviderOrder() {
  while (true) {
    const { payload } = yield take(PlatformConfigurationConst.POST_SOCIAL_PROVIDERS_ORDER);
    yield call(postSocialProviderOrderHandler, payload);
  }
}
